import { progressKey } from './identity.js';
import { computeStats, type ResultRow, type UserStats } from '@decathlon/shared';

/** Local result history so guests get progress graphs too; accounts also post to the server. */
const KEY = 'decathlon.history';
const CAP = 500;

export function loadHistory(): ResultRow[] {
  try {
    const rows = JSON.parse(localStorage.getItem(progressKey(KEY)) ?? '[]') as ResultRow[];
    return Array.isArray(rows) ? rows : [];
  } catch {
    return [];
  }
}

export function recordLocal(row: ResultRow): boolean {
  const rows = loadHistory();
  if (row.resultKey && rows.some((r) => r.resultKey === row.resultKey)) return false;
  rows.push(row);
  try {
    localStorage.setItem(progressKey(KEY), JSON.stringify(rows.slice(-CAP)));
  } catch {
    /* ignore */
  }
  return true;
}

export function localStats(name: string): UserStats {
  return computeStats(name, loadHistory());
}
